import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccountId } from '../../../redux/slices/appInfo/hooks';
import { SmartLinkSheetFrom, smartLinkSheetSongPath } from './smartLinkSheetSong';

/**
 * Opens the SmartLinks page with the creation sheet open and the catalog song picked
 * (`/smartlinks?catalogItemUuid=<uuid>`). The sheet opens on the song as soon as the catalog read
 * holds the row. An empty uuid does nothing. `from: 'addSong'` (the add-song Done step) makes the
 * sheet publish the page at once.
 */
export function useOpenSmartLinkSheetForSong(): (
  catalogItemUuid: string,
  options?: { from?: SmartLinkSheetFrom }
) => void {
  const navigate = useNavigate();
  const accountId = useAccountId();
  return useCallback(
    (catalogItemUuid: string, options?: { from?: SmartLinkSheetFrom }) => {
      if (catalogItemUuid === '') {
        return;
      }
      // eslint-disable-next-line no-void
      void navigate(smartLinkSheetSongPath(catalogItemUuid, accountId, options?.from));
    },
    [accountId, navigate]
  );
}
